// Use this for any shared settings that cross environment bounds.
// TODO: Setup explicit permissions if applicable to your Frontend web application.
// See https://gitlab.com/ZonarSystems/tools/pattern-library/-/tree/master/projects/zonar-ui-auth#Permissions for details

export const permissions = {
  defaultRedirectUrl: '/',
  defaultPermPrefix: 'manage_zone',
  routes: [['/', 'read:zones']],
};

export const appName = 'Manage Zone';
export const appVersion = '0.0.1';

export const httpRetryCount = 3;

